import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
	interviewCategoriesGet,
	interviewCategoryGetById,
	interviewCategoryCreate,
	interviewCategoryUpdate,
	interviewCategoryDelete
} from "api/menu/hr/interview-categories/requests";

export const FETCH_INTERVIEW_CATEGORIES_SUCCESS = "FETCH_INTERVIEW_CATEGORIES_SUCCESS";
export const FETCH_INTERVIEW_CATEGORY_BY_ID_SUCCESS = "FETCH_INTERVIEW_CATEGORY_BY_ID_SUCCESS";
export const INTERVIEW_CATEGORIES_REQUEST_LOADING = "INTERVIEW_CATEGORIES_REQUEST_LOADING";
export const INTERVIEW_CATEGORIES_REQUEST_ERRORS = "INTERVIEW_CATEGORIES_REQUEST_ERRORS";

export const setLoading = () => ({ type: INTERVIEW_CATEGORIES_REQUEST_LOADING });

export const fetchInterviewCategories = (includeInactive = false) => dispatch => {
	dispatch(setLoading());
	interviewCategoriesGet(includeInactive)
		.then(response => {
			dispatch({ type: FETCH_INTERVIEW_CATEGORIES_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_CATEGORIES_REQUEST_ERRORS));
		});
};

export const fetchInterviewCategoryById = (id) => dispatch => {
	interviewCategoryGetById(id)
		.then(response => {
			dispatch({ type: FETCH_INTERVIEW_CATEGORY_BY_ID_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_CATEGORIES_REQUEST_ERRORS));
		});
};

export const createInterviewCategory = (data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewCategoryCreate(data)
		.then(response => {
			dispatch(formErrorLoading(false));
			toast(`Category "${data.name}" created`, { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const updateInterviewCategory = (id, data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewCategoryUpdate(id, data)
		.then(() => {
			dispatch(formErrorLoading(false));
			toast(`Category "${data.name}" updated`, { type: toast.TYPE.SUCCESS });
			if (callback) callback(true);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const deleteInterviewCategory = (id, name, callback = false) => dispatch => {
	dispatch(setLoading());
	interviewCategoryDelete(id)
		.then(() => {
			toast(`Category "${name}" deleted`, { type: toast.TYPE.SUCCESS });
			if (callback) callback();
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_CATEGORIES_REQUEST_ERRORS));
		});
};

export const clearInterviewCategories = () => dispatch => {
	dispatch({ type: FETCH_INTERVIEW_CATEGORIES_SUCCESS, payload: [] });
};

export const clearSingleInterviewCategory = () => dispatch => {
	dispatch({ type: FETCH_INTERVIEW_CATEGORY_BY_ID_SUCCESS, payload: {} });
};
